import React, { Component } from "react";

import Footer from "../Utils/Footer/Footer";
import Header from "../Utils/Header/Header";
import * as DATA from "./data.json";

import "../Faculty/Faculty.css";

export default class Awardees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
      selectedMember: {},
      openDialog: false,
      displayRoute: props.displayRoute,
      imageNumber: 1,
      texts: ["Faculty Details Coming Soon."],
    };
  }

  componentDidMount() {}
  render() {
    return (
      <div className="screen-container">
        <Header {...this.props} />

        <div className="faculty-screen-wrapper">
          <div className="faculty-content-section">
            <h1 style={{ textAlign: "center" }}>Travel Grant Awardees</h1>

            <div className="faculty-list-wrapper">
              {DATA.Travel_Grant_Awardees &&
                DATA.Travel_Grant_Awardees.map((member, index) => (
                  <div className="faculty-member" key={index}>
                    <div className="faculty-member-name">{member.name}</div>
                  </div>
                ))}
            </div>

            <h1 className="heading-title">Best Poster Awards</h1>

            <div className="faculty-list-wrapper">
              {DATA.Best_Poster_Awards &&
                DATA.Best_Poster_Awards.map((member, index) => (
                  <div className="faculty-member" key={index}>
                    <div className="faculty-member-name">{member.name}</div>
                    <div className="faculty-member-location">{member.position}</div>
                  </div>
                ))}
            </div>

            <h1 className="heading-title">Online Quiz Awards</h1>

            <div className="faculty-list-wrapper">
              {DATA.Online_Quiz_Awards &&
                DATA.Online_Quiz_Awards.map((member, index) => (
                  <div className="faculty-member" key={index}>
                    <div className="faculty-member-name">{member.name}</div>
                    {/* <div className="faculty-member-location">{member.location}</div> */}
                    <div className="faculty-member-location">({member.position})</div>
                  </div>
                ))}
            </div>
          </div>
        </div>

        <Footer {...this.props} />
      </div>
    );
  }
}
